import React from 'react';
import QuizWrapper from "./StudentPages/Quiz/QuizWrapper";
import Navbar from "./components/Navbar";
import Home from './StudentPages/Home'
import { Switch, Route } from 'react-router-dom'
import PronunciationWrapper from "./StudentPages/Pronunciation/PronunciationWrapper";
import TranslationFlashCardWrapper from "./StudentPages/TranslationFlashCards/TranslationFlashCardWrapper";
import DialogFlashCardWrapper from "./StudentPages/DialogFlashCards/DialogFlashCardWrapper";
import DialogWrapper from "./StudentPages/Dialog/DialogWrapper";
import AdminWrapper from "./Admin/AdminWrapper";
import Footer from "./components/Footer";

function App(
    {
        userName,
        classLevel,
        loading,
        loginStatus,
        loginUser,
        logoutUser,
        handleClassLevel,

    }
) {



  return (
    <>
        <Navbar
            userName={userName}
            loginStatus={loginStatus}
            loginUser={loginUser}
            loading={loading}
            logoutUser={logoutUser}
        />
        <Switch>
            <Route exact path='/'>
                <Home
                handleClassLevel={handleClassLevel}
                classLevel={classLevel}/>
            </Route>

            <Route path='/dialogConversation'>
                <DialogWrapper
                    classLevel={classLevel}
                />
                <Footer/>
            </Route>
            <Route path='/quizzes'>
                <QuizWrapper
                    classLevel={classLevel}
                />
                <Footer/>
            </Route>
            <Route path='/pronunciation'>
                <PronunciationWrapper
                    classLevel={classLevel}
                />
                <Footer/>
            </Route>
            <Route path='/translation'>
                <TranslationFlashCardWrapper
                    classLevel={classLevel}
                />
                <Footer/>
            </Route>
            <Route path='/dialogFlashCard'>
                <DialogFlashCardWrapper
                    classLevel={classLevel}
                />
                <Footer/>
            </Route>
            <Route path='/admin'>
                <AdminWrapper
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
                />
            </Route>
        </Switch>
    </>
  );
}

export default App;
